export default __webpack_public_path__ + "static/media/pamm-laptop.e44bb9a2.png";